import { SystemAuthorizations } from 'shell/authorizations/system';
import { HeadCell } from 'shell/components/shared/table/types';
import { ProcessingJobClient } from './types';
import * as yup from 'yup';

export const authsObj = Object.freeze({
  read: [SystemAuthorizations.BatchAdmin],
});

export const headCells: HeadCell<ProcessingJobClient, keyof ProcessingJobClient>[] = [
  {
    id: 'id',
    label: 'Id',
  },
  {
    id: 'batchName',
    label: 'Nome Batch',
    colSpan: 2,
  },
  {
    id: 'sent',
    label: 'Date ora inoltro',
  },
  {
    id: 'startedAt',
    label: 'Data ora inizio',
  },
  {
    id: 'completedAt',
    label: 'Data ora fine',
  },
  {
    id: 'numInput',
    label: 'Num input',
  },
  {
    id: 'numOutput',
    label: 'Num output',
  },
  {
    id: 'numError',
    label: 'Num errori',
  },
  {
    id: 'numWarning',
    label: 'Num warning',
  },
  {
    id: 'state',
    label: 'Stato',
  },
  {
    id: 'action',
    label: '',
  },
];

export const validationSchemaBatchFilter = yup.object({});
